import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import "./scss/style.scss";
import "./childcomp/table/tableDesign.scss";
import Spinners from "./childcomp/spinners/Spinners";
import * as permission from "./routes/permission";
import "moment/locale/vi";

//
const loading = () => <Spinners />;
// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));
// Pages
const Register = React.lazy(() => import("./views/Pages/Register/Register"));
const Login = React.lazy(() => import("./views/Pages/Login/Login"));
const Map = React.lazy(() => import("./views/Pages/Home/Index"));
const Home = React.lazy(() => import("./views/Home"));
const TruyXuat = React.lazy(() => import("./views/TruyXuatThongTin/Index"));
// const MapMobile = React.lazy(() => import('./views/Map/IndexMobile'));
// const MapMobile = React.lazy(() => import('./views/MapLeaf/IndexLeaft'));
///
export default class App extends Component {
  componentDidMount() {}
  render() {
    return (
      <BrowserRouter>
        <React.Suspense fallback={loading()}>
          {permission.checkLogin() ? (
            <Switch>
              <Route
                path="/"
                name="Home"
                render={(props) => <DefaultLayout {...props} />}
              />
            </Switch>
          ) : (
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <Route
                exact
                path="/register"
                name="Register Page"
                render={(props) => <Register {...props} />}
              />
              <Route
                exact
                path="/truy-xuat"
                name="Truy xuat"
                render={(props) => <TruyXuat {...props} />}
              />
              <Route exact path="/map/:place?" name="Home Page">
                <Map />
              </Route>

              <Route exact path="/" name="Home Page">
                <Home />
              </Route>
              {/* <Redirect to={{ pathname: "/map" }} /> */}
            </Switch>
          )}
        </React.Suspense>
      </BrowserRouter>
    );
  }
}
